import { RouteRecordRaw } from 'vue-router';
import { MasterListPage } from '@/pages/master-list';

export const routeName = 'ListaMestra';

export const route: RouteRecordRaw = {
  path: 'gestao-documentos/lista-mestra',
  name: routeName,
  component: MasterListPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Lista Mestra',
    permissions: [
      { action: 'createMasterList', subject: 'Document' },
      { action: 'manage', subject: 'DocumentManagement' },
    ],
    matchMode: 'any',
  },
};
